import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const API_BASE_URL = process.env.REACT_APP_API_URL;

class TrashService {
  constructor() {
    this.baseUrl = `${API_BASE_URL}/api/v2/trash`;
  }

  async getRecentlyDeletedItems() {
    try {
      const headers = getAuthHeaders(true);
      const response = await axios.get(`${this.baseUrl}/items`, { headers });
      return response.data;
    } catch (error) {
      console.error('Error fetching deleted items:', error);
      throw error;
    }
  }

  async restoreDeletedItem(itemId, newParentPath = null) {
    try {
      const headers = getAuthHeaders(true);
      const url = `${this.baseUrl}/restore/${itemId}`;
      const params = newParentPath ? { newParentPath } : {};

      const response = await axios.post(url, null, { headers, params });
      return response.data;
    } catch (error) {
      console.error('Error restoring item:', error);
      throw error;
    }
  }

  async permanentlyDeleteItem(itemId) {
    try {
      const headers = getAuthHeaders(true);
      await axios.delete(`${this.baseUrl}/permanent/${itemId}`, { headers });
      return true;
    } catch (error) {
      console.error('Error permanently deleting item:', error);
      throw error;
    }
  }
}

export default new TrashService();